import noop from '/utils/noop'

const isImageReady = media => media.complete && media.naturalWidth !== 0

export default async (media, callback = noop) => {
  await (
    media instanceof HTMLImageElement
      // Re-check `complete` right before resolving: on mobile (notably
      // Chrome Android) a lazy-loaded image can finish loading between
      // querySelectorAll() and the `load` listener being attached, so the
      // event never fires and the promise would hang forever, leaving the
      // image stuck at opacity: 0.
      ? isImageReady(media) ||
        new Promise(resolve => {
          if (isImageReady(media)) return resolve()
          media.addEventListener('load', resolve, { once: true })
        })
      : media instanceof HTMLVideoElement
        ? (media.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) ||
        new Promise(resolve => media.addEventListener('canplay', resolve, { once: true }))
        : true
  )

  return callback(media)
}
